import React from 'react';
import PropTypes from 'prop-types';

const Copy = ({ fill, theme, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.26 5.62H14.12C14.8211 5.62264 15.4926 5.903 15.9874 6.39969C16.4822 6.89637 16.76 7.5689 16.76 8.27V19.93C16.76 20.6311 16.4822 21.3036 15.9874 21.8003C15.4926 22.297 14.8211 22.5773 14.12 22.58H5.26C4.55718 22.58 3.88314 22.3008 3.38617 21.8038C2.8892 21.3069 2.61 20.6328 2.61 19.93V8.27C2.61 7.56717 2.8892 6.89313 3.38617 6.39616C3.88314 5.89919 4.55718 5.62 5.26 5.62ZM14.12 20.62C14.2995 20.6174 14.471 20.5449 14.598 20.418C14.7249 20.291 14.7974 20.1195 14.8 19.94V8.27C14.8 8.08965 14.7284 7.91669 14.6008 7.78916C14.4733 7.66164 14.3003 7.59 14.12 7.59H5.26C5.07965 7.59 4.90669 7.66164 4.77917 7.78916C4.65164 7.91669 4.58 8.08965 4.58 8.27V19.93C4.58258 20.1095 4.65506 20.281 4.78203 20.408C4.90899 20.5349 5.08046 20.6074 5.26 20.61L14.12 20.62Z"
      fill={fill || theme.COLORS.primary}
    />
    <path
      d="M18.74 1.41998H10.56C9.92613 1.41998 9.31823 1.67179 8.87001 2.12C8.4218 2.56821 8.17 3.17612 8.17 3.80998C8.17 4.0752 8.27536 4.32955 8.46289 4.51709C8.65043 4.70463 8.90478 4.80998 9.17 4.80998C9.43521 4.80998 9.68957 4.70463 9.8771 4.51709C10.0646 4.32955 10.17 4.0752 10.17 3.80998C10.17 3.69859 10.2142 3.59176 10.293 3.513C10.3718 3.43423 10.4786 3.38998 10.59 3.38998H18.77C18.9495 3.39257 19.121 3.46504 19.248 3.59201C19.3749 3.71898 19.4474 3.89044 19.45 4.06998V15.07C19.4513 15.126 19.4415 15.1817 19.4209 15.2338C19.4004 15.2859 19.3697 15.3334 19.3306 15.3735C19.2914 15.4135 19.2447 15.4454 19.1931 15.4671C19.1414 15.4888 19.086 15.5 19.03 15.5H18.52C18.2548 15.5 18.0004 15.6053 17.8129 15.7929C17.6254 15.9804 17.52 16.2348 17.52 16.5C17.52 16.7652 17.6254 17.0196 17.8129 17.2071C18.0004 17.3946 18.2548 17.5 18.52 17.5H19C19.6348 17.4973 20.2427 17.2433 20.6906 16.7935C21.1385 16.3437 21.39 15.7348 21.39 15.1V4.09998C21.394 3.74946 21.3284 3.40164 21.197 3.07666C21.0656 2.75167 20.871 2.45599 20.6245 2.20673C20.378 1.95746 20.0846 1.75958 19.7611 1.62453C19.4376 1.48949 19.0905 1.41996 18.74 1.41998Z"
      fill={fill || theme.COLORS.primary}
    />
  </svg>
);

Copy.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default Copy;
